<template>
    <div class="position-relative">
        <div class="quem-utiliza px-4 py-5">
            <div class="container">
                <div class="mx-7">
                    <div class="row mt-4">
                        <div class="col-12 col-md-6 pe-md-5 d-flex justify-content-end">
                            <div class="w-100 d-flex align-items-center justify-content-between">
                                <span class="txt-p txt-white txt-size-35 txt-w-bold">
                                    Quem utiliza:
                                </span>
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 col-md-4 mt-5" v-for="(item,index) in quemUtiliza" :key="index">
                            <div class="item-quem-utiliza mx-2 d-flex align-items-center justify-content-center">
                                <img class="icone-quem-utiliza" :src="item.icon" />
                                <span class="txt-p txt-size-20 txt-white txt-w-5 ">{{item.nome}}</span>
                            </div>
                        </div>
                        <div class="col-12 col-md-8 mt-5 d-flex justify-content-center align-items-center ">
                            <div class="w-50 ">
                                <p class="mb-0 txt-p txt-size-18 txt-white txt-w-4">
                                    ...e outros <span class="txt-size-24 txt-w-7">agentes que atuam</span> <br />com <span class="txt-size-24 txt-w-7">contratação pública.</span>
                                </p>
                            </div>

                        </div>
                    </div>
                    <div class="row mt-5 text-center justify-content-center">
                        <div class="col-6" style="z-index: 4;">
                            <button class="btn btn-roxo px-5" @click="contato">
                                QUERO SOLICITAR CONTATO!
                            </button>
                        </div>

                    </div>
                </div>
            </div>

        </div>

        <div class="bg-cinza-curvado-concavo"></div>
    </div>
    
</template>

<script>
    import userHammer from '@/assets/img/icon/user-hammer.png'
    import userPencil from '@/assets/img/icon/user-pencil.png'
    import users from '@/assets/img/icon/users.png'
    import usersGear from '@/assets/img/icon/users-gear.png'
    import userSuit from '@/assets/img/icon/user-suit.png'
    import userBalance from '@/assets/img/icon/user-balance.png'
    import userMagnifying from '@/assets/img/icon/user-magnifying.png'

    export default {
        name: 'QuemUtiliza',
        data: function () {
            return {
                quemUtiliza: [
                    { nome: "Assessores Jurídicos", icon: userSuit },
                    { nome: "Advogados", icon: userBalance },
                    { nome: "Pareceristas", icon: userMagnifying },
                    { nome: "Procuradores", icon: userSuit },
                    { nome: "Pregoeiros", icon: userHammer },
                    { nome: "Comissões de licitação", icon: users },
                    { nome: "Equipes de apoio", icon: users },
                    { nome: "Fiscais de contrato", icon: userPencil },
                    { nome: "Gestores de contrato", icon: usersGear },
                    { nome: "Assessores de Gabinete", icon: userSuit },
                ],
            }
        },
        methods: {
            contato() {
                this.$router.push({ name: 'Planos' });
            }

        },
        created: function () {
        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .mt-4 {
        margin-top: 4rem;
    }

    .quem-utiliza {
        /*height: 784px;*/
        background-image: url(../assets/img/bg-quem-utiliza.png);
        background-repeat: no-repeat;
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: cover; /* Resize the background image to cover the entire container */
    }

    .item-quem-utiliza {
        background-image: linear-gradient(white, white), linear-gradient(white, white), linear-gradient(white, white), linear-gradient(white, white), linear-gradient(transparent, transparent);
        background-repeat: no-repeat;
        background-size: 4px 60%, 100% 4px, 4px 100%, 87% 4px, calc(100% - 8px) calc(100% - 8px);
        background-position: left bottom, left bottom, right top, right top, 4px 4px;

        border-radius: 10px;
        padding: 25px;
        position: relative;
    }

    .item-quem-utiliza .icone-quem-utiliza {
        position: absolute;
        top: -20px;
        left: -20px;
        width: 60px;
        height: auto;
    }

    .bg-cinza-curvado-concavo {
        width: 100%;
        height: 200px;
        position: absolute;
        bottom: -5rem;
        z-index: 3;
        background-image: url(../assets/img/retangulo-curvado-home.png);
        background-color: transparent;
        background-repeat: no-repeat;
        background-position: top;
    }
</style>

